import { format } from 'date-fns';

export const TIMEFRAME_PRESETS = [
  { key: '1h', label: 'Last hour', durationMs: 60 * 60 * 1000 },
  { key: '6h', label: 'Last 6 hours', durationMs: 6 * 60 * 60 * 1000 },
  { key: '24h', label: 'Last 24 hours', durationMs: 24 * 60 * 60 * 1000 },
  { key: '7d', label: 'Last 7 days', durationMs: 7 * 24 * 60 * 60 * 1000 },
  { key: '30d', label: 'Last 30 days', durationMs: 30 * 24 * 60 * 60 * 1000 },
  { key: '90d', label: 'Last 90 days', durationMs: 90 * 24 * 60 * 60 * 1000 },
  { key: 'all', label: 'All time' },
  { key: 'custom', label: 'Custom range' },
];

export const DEFAULT_TIMEFRAME_KEY = '24h';

export function findTimeframePreset(key) {
  return TIMEFRAME_PRESETS.find((p) => p.key === key);
}

export function createRangeFromDuration(durationMs, anchor = Date.now()) {
  const before = anchor;
  const since = Math.max(0, before - (durationMs || 0));
  return { since, before };
}

export function getDefaultTimeRange(key = DEFAULT_TIMEFRAME_KEY) {
  const duration = getPresetDuration(key);
  if (duration === null) {
    return { since: null, before: null };
  }
  return createRangeFromDuration(duration || 24 * 60 * 60 * 1000);
}

export function formatTimeRangeLabel(since, before) {
  try {
    if (!Number.isFinite(since) || !Number.isFinite(before)) return '';
    const start = new Date(since);
    const end = new Date(before);
    if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return '';
    const startLabel = format(start, 'MMM d, yyyy p');
    const endLabel = format(end, 'MMM d, yyyy p');
    return `${startLabel} – ${endLabel}`;
  } catch {
    return '';
  }
}

export function getPresetDuration(key) {
  const preset = findTimeframePreset(key);
  return preset?.durationMs || null;
}
